import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { MOUSE } from 'three'

export default class Controls {
  constructor(camera, domElement) {
    this.camera = camera;
    this.domElement = domElement;
    this.orbit = new OrbitControls(this.camera, this.domElement);
    this.orbit.mouseButtons = {LEFT: MOUSE.LEFT, MIDDLE: MOUSE.RIGHT, RIGHT: MOUSE.MIDDLE}
    return this.orbit
  }
}